import { render, staticRenderFns } from "./ReminderStatus.vue?vue&type=template&id=7efed50e&"
import script from "./ReminderStatus.vue?vue&type=script&lang=js&"
export * from "./ReminderStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports